<template>
  <div class="filterBody" :class="{'filterBody-extend': whetherHadBeExtend}">
    <el-form ref="form" :inline="true" :model="formValues" class="form">
      <el-col :span="19">
        <el-form-item v-for="field in fields" :label="field.name" :key="field.id" class="label" :class="field.class">
          <el-input clearable class="input" v-model="formValues[field.key]" :placeholder="field.placeholder ? field.placeholder : field.name" v-if="field.type === 'input'" :size="field.size ? field.size : 'small'" />
          <el-input clearable class="input" type="number" v-model="formValues[field.key]" :placeholder="field.placeholder ? field.placeholder : field.name" v-if="field.type === 'number'" :size="field.size ? field.size : 'small'" />
          <el-select class="input" filterable clearable :size="field.size ? field.size : 'small'" style="width: 100%" v-model="formValues[field.key]" v-else-if="field.type === 'select'" :placeholder="field.name">
            <el-option
              v-for="item in field.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            clearable
            v-else-if="field.type === 'date'"
            v-model="formValues[field.key]"
            :size="field.size ? field.size : 'small'"
            type="datetime"
            class="input"
            value-format="yyyy-MM-dd"
            :placeholder="field.placeholder ? field.placeholder : field.name">
          </el-date-picker>
          <el-cascader
            v-if="field.type === 'cascader' && field.options"
            clearable
            :size="field.size ? field.size : 'small'"
            style="width: 100%"
            v-model="formValues[field.key]"
            :options="field.options"
            :show-all-levels="field.showAllLevels"
            :props="field.props ? field.props : { checkStrictly: true, children: 'sub', label: 'name', value: 'id' }"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item class="operate" >
          <i v-if="!whetherHadBeExtend" class="fa fa-angle-double-down icon" @click="extend"></i>
          <i v-else-if="whetherHadBeExtend" class="fa fa-angle-double-up icon" @click="extend"></i>
          <el-button @click="submit" type="primary" class="button">查询</el-button>
          <el-button @click="reset" class="button">重置</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'filterForm',
    props: {
      fields: Array,
    },
    data() {
      return {
        formValues: { },
        timer: {start_time: Number,end_time: Number},
        whetherHadBeExtend: false,
      }
    },
    methods: {
      submit() {
        // if(String(Math.abs(this.formValues.start_time)).length>10){
        //   this.timer.start_time = Number(JSON.stringify(this.formValues.start_time))/1000;
        // }
        // if(String(Math.abs(this.formValues.end_time)).length>10){
        //   this.timer.end_time = Number(JSON.stringify(this.formValues.end_time))/1000;
        // }
        // var submitObj = JSON.parse(JSON.stringify(this.formValues))
        // if(submitObj.start_time){
        //   submitObj.start_time = this.timer.start_time
        // }
        // if(submitObj.end_time){
        //   submitObj.end_time = this.timer.end_time
        // }
        this.$emit('submit', this.formValues);
      },
      extend() {
        this.whetherHadBeExtend = !this.whetherHadBeExtend;
      },
      reset() {
        this.formValues = {};
        this.$refs.form.resetFields();
        this.$emit('submit', {})
      }
    }
  }
</script>

<style lang="scss" scoped>

.filterBody {
  height: 90px;
  overflow: hidden;
  transition: height 300ms;
  margin-bottom: 1.2vw;
  background: #fff;
  &-extend {
    height: auto;
    overflow: initial;
  }
}
.button {
  // border-radius: 20px;
  height: 2.1vw;
  letter-spacing: 0.2vw;
  padding: 0;
  width: 5.7vw;
}

.form {
  display: flex;
  padding-top: 1.4vw;
  padding-left: 1.9vw;
  box-sizing: border-box;
}
.input /deep/ input {
  // width: 9.2vw;
  // height: 2.2vw;
	// border: solid 1px #c1c1c1;
}

.operate {
  display: flex;
  & /deep/ .el-form-item__content {
    display: flex;
  }
}
.label {
  float: left;
  min-height: 43px;
  & /deep/ .el-form-item__label {
    font-size: 0.7vw;
  }
}
.icon {
  cursor: pointer;
  font-size: 27px;
  color: #999;
  &:hover {
    transition: 300ms;
    color: #666;
  }
}
</style>